import React from 'react'
import Slides from '../slides/Slides'
import Uif from './Uif'
import Afip from './Afip'
import Ssn from './Ssn'
import Srt from './Srt'

const Normativa = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides={"normativa"}/>
         <div className="animated fadeIn">
            <div className="container section">
               <Uif/>
               <Afip/>
               <Ssn/>
               <Srt/>
            </div>
         </div>
      </>
   )
}
export default Normativa